import { API_PREFIX, paginatedFromDto, type HttpClient } from "@nasam/kernel";
import type { AlertHistoryRepository } from "../domain";
import {
  alertEvidenceResponseDtoSchema,
  alertHistoryDetailResponseDtoSchema,
  alertHistoryListResponseDtoSchema,
  alertHistoryTypesResponseDtoSchema,
} from "./alertHistoryDtos";
import {
  alertHistoryDetailsFromDto,
  alertHistoryItemFromDto,
} from "./alertHistoryMappers";

const HISTORY_PATH = `${API_PREFIX}/alerts/history`;

export function createAlertHistoryHttpRepository(
  http: HttpClient,
): AlertHistoryRepository {
  return {
    async list(query) {
      const response = await http.get(HISTORY_PATH, { params: query });
      return paginatedFromDto(
        alertHistoryListResponseDtoSchema.parse(response),
        alertHistoryItemFromDto,
      );
    },
    async getById(id) {
      const response = await http.get(
        `${HISTORY_PATH}/${encodeURIComponent(id)}`,
      );
      const { data } = alertHistoryDetailResponseDtoSchema.parse(response);
      return {
        ...alertHistoryItemFromDto(data),
        details: alertHistoryDetailsFromDto(data.details),
      };
    },
    async listTypes() {
      const response = await http.get(`${HISTORY_PATH}/types`);
      return alertHistoryTypesResponseDtoSchema.parse(response).data;
    },
    async listEvidence(id) {
      // Asked again each time: the links expire 10 minutes after the request.
      const response = await http.get(
        `${HISTORY_PATH}/${encodeURIComponent(id)}`,
      );
      return alertEvidenceResponseDtoSchema.parse(response).data.evidence ?? [];
    },
  };
}
